
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Projet Gemini',
	'appExit': 'Accéder à la page d\'accueil',


	'widgetsListLabel': 'Liste des widgets. Sélectionnez un widget et appuyez sur Entrer pour l\'ajouter.',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': 'A jour',
	'dirty': 'Pas à jour',
	'conflict': 'Conflit lors de l\'enregistrement de la vue',
	'error': 'Problème lors de l\'enregistrement de la vue',
	'failure': 'Impossible d\'établir le contact avec le serveur',
	'saveFailed': 'Impossible de sauvegarder la vue',

	'wa_insync': 'Enregistrée',
	'wa_conflict': 'Conflit lors de l\'enregistrement de la vue',
	'wa_error': 'Impossible de sauvegarder la vue',
	'wa_failure': 'Impossible d\'établir le contact avec le serveur',

	// Menu Labels
	'changeDisplay': 'Modifier l\'affichage',
	'changeToColumnChart': 'Remplacer par Graphique à colonnes',
	'changeToBubbleChart': 'Remplacer par Graphique à bulles',
	'toggleMoveHandles': 'Activer/désactiver les poignées',
	'undo': 'Annuler',
	'redo': 'Rétablir',
	'mode': 'Changer de mode',

	'untitled': 'Sans titre',
	'remove': 'Retirer',
	'editTitle': 'Editer le titre',
	'edit': 'Editer',
	'done': 'Terminé',

	// Data tray
	'dataTrayHandleOpenLabel': 'Ouvrir le plateau de données',
	'dataTrayHandleCloseLabel': 'Fermer le plateau de données',

	// Dialogs
	'dlg_loading': 'Chargement...',
	'dlg_ok': 'OK',
	'dlg_create': 'Créer',
	'dlg_cancel': 'Annuler',
	'dlg_close': 'Fermer',
	'dlg_update': 'Mettre à jour',
	'dlg_renameBoardTitle': 'Renommer cet objet',
	'dlg_renameDatasetTitle': 'Renommer cet ensemble de données',
	'dlg_renameSceneTitle': 'Renommer cette scène',
	'dlg_NameLabel': 'Nom :',
	'dlg_NewNameLabel': 'Nouveau nom :',
	'dlg_DefaultNameWithDataSet': 'Vue %{name}',
	'dlg_ShareTitle': 'Partager le contenu',
	'dlg_UnshareTitle': 'Retirer le partage de contenu',
	'dlg_ShareUser': 'ID utilisateur :',
	'dlg_NewColumnLabel': 'Nouveau nom de calcul',

	'dlg_new': 'Nouveau...',
	'dlg_open': 'Ouvrir...',
	'dlg_makeACopy': 'Créer une copie',
	'dlg_rename': 'Renommer...',
	'dlg_moreToCome': 'Autres actions à venir...',

	'dlg_use': 'Utiliser',

	'dlg_RelinkDatasetTitle': 'Remplacer l\'ensemble de données \'%{datasetName}\' par...',

	'open_error': 'Un problème s\'est produit lors de l\'ouverture de la vue.',

	// Delete Board
	'del_dialogTitle': 'Confirmer la suppression',
	'del_itemMsg': 'Voulez-vous vraiment supprimer \'%{name}\' ?',
	'del_itemsMsg': 'Voulez-vous vraiment supprimer %{count} éléments ?',
	'del_deleteErr': 'Impossible de supprimer \'%{name}\'',

	// List Sorting
	'dlg_ascending': 'croissant',
	'dlg_descending': 'décroissant',
	'dlg_custom': 'personnalisé',
	'dlg_none': 'aucun',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': 'Rechercher',

	'searchHint': 'Rechercher dans toutes vos données',
	'clearSearchResult': 'Effacer les résultats de recherche',
	// Shapes and shapes categories
	// Basic shapes
	'shapesBasicShapesCat': 'De base',
	'shapesCircle': 'Cercle',
	'shapesHexagon': 'Hexagone',
	'shapesLine': 'Courbe',
	'shapesOctagon': 'Octogone',
	'shapesPentagon': 'Pentagone',
	'shapesSquare': 'Carré',
	'shapesTriangle': 'Triangle',
	'shapesDiamond': 'Losange',
	'shapesTitle': 'Propriétés des formes',


	// Advanced shapes
	'shapesAdvancedShapesCat': 'Avancé',
	'shapesSquareRounded': 'Carré arrondi',
	'shapesStar': 'Etoile',
	'shapesChevron': 'Chevron',
	'shapesBadge_ribbon': 'Ruban du badge',
	'shapesBadge': 'Badge',
	'shapesHeart': 'Coeur',
	'shapesExclamation': 'Exclamation',
	'shapesTrendingup': 'Tendance à la hausse',
	'shapesTrendingdown': 'Tendance à la baisse',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': 'Personnes',
	'shapesFemale': 'Féminin',
	'shapesHappyface': 'Visage joyeux',
	'shapesMale': 'Masculin',
	'shapesMan': 'Homme',
	'shapesNeutralface': 'Visage neutre',
	'shapesSadface': 'Visage triste',
	'shapesShakehands': 'Poignée de mains',
	'shapesThumbsdown': 'Pouces vers le bas',
	'shapesThumbsup': 'Pouces vers le haut',
	'shapesWoman': 'Femme',

	// Weather and places
	'shapesPlacesWeatherCat': 'Lieux et météo',
	'shapesCity': 'Ville',
	'shapesCloud': 'Nuage',
	'shapesEducation': 'Formation',
	'shapesGovernment': 'Administrations publiques',
	'shapesHalfcloud': 'Demi-nuage',
	'shapesHouse': 'Maison',
	'shapesMoon': 'Lune',
	'shapesRain': 'Pluie',
	'shapesSunny': 'Soleil',

	//Vehicles
	'shapesVehiclesCat': 'Véhicules',
	'shapesAirplane': 'Avion',
	'shapesCar': 'Voiture',
	'shapesShip': 'Bateau',
	'shapesShoppingcart': 'Chariot',
	'shapesTrain': 'Train',
	'shapesTruck': 'Camion',

	//Objects
	'shapesObjectsCat': 'Objets',
	'shapesBook': 'Classeur',
	'shapesBriefcase': 'Porte-documents',
	'shapesCalendar': 'Calendrier',
	'shapesCheck': 'Coche',
	'shapesClock': 'Horloge',
	'shapesDesktop': 'Bureau',
	'shapesDocument': 'Document',

	'shapesFood': 'Aliment',
	'shapesGear': 'Engrenage',
	'shapesHealth': 'Santé',

	'shapesIdea': 'Idée',
	'shapesMobile': 'Mobile',
	'shapesMoney_bill': 'Billet',
	'shapesMoney_coin': 'Pièces',
	'shapesPiggybank': 'Tirelire',
	'shapesStackofpaper': 'Pile de papier',
	'shapesStickynote1': 'Pense-bête 1',
	'shapesStickynote2': 'Pense-bête 2',
	'shapesTarget': 'Cible',
	'shapesTool': 'Outil',

	'shapesUmbrella': 'Parapluie',

	'shapesBrain': 'Cerveau',
	'shapesSkull': 'Crâne',
	'shapesEye': 'Oeil',

	// Arrows shapes
	'shapesArrowsCat': 'Flèches',
	'shapesRightArrow': 'Flèche vers la droite',
	'shapesLeftArrow': 'Flèche vers la gauche',
	'shapesDoubleArrow': 'Double flèche',
	'shapesCurvedArrow': 'Flèche courbe',

	// Callouts shapes
	'shapesCalloutsCat': 'Légendes',
	'shapesRectCallout': 'Légende',

	// Images
	'imageWidgetTitle': 'Widget d\'image',
	'imageTextLabel': 'Coller l\'URL et appuyer sur Entrée pour l\'enregistrer',
	'imgUrl': 'URL de l\'image',
	'imgPasteLink': 'Coller l\'URL et appuyer sur Entrée pour l\'enregistrer',
	'imgResizeToFit': 'Redimensionner en fonction de la taille de l\'image',
	'imgHeight': 'Hauteur :',
	'imgWidth': 'Largeur :',
	'imgTransparency': 'Transparence :',
	'imgMissingUrl': 'L\'URL de l\'image est manquante',
	'imgUrlValidationError': 'L\'URL de l\'image n\'est pas valide',
	'imgUrlInvalidDomainError': 'L\'URL de l\'image pointe vers un domaine qui n\'a pas été approuvé par votre administrateur. Les domaines approuvés par votre administrateur sont "%{domains}"',


	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': 'Lire',
	'dataPlayerValueListLabel': 'Valeurs de lecteur de données',
	// Text Widget
	'textWidgetTitle': 'Widget de texte',
	'textStyle': 'Styles',
	'textStyleDescription': 'Styles de texte préformatés',
	'textTitleStyle': 'Titre',
	'textTitleSmallStyle': 'Petit titre',
	'textSubtitleStyle': 'Sous-titre',
	'textBodyStyle': 'Corps',
	'textBodySmallStyle': 'Petit corps',
	'textCaptionStyle': 'Légende',
	'textQuoteStyle': 'Apostrophe',
	'textQuoteSmallStyle': 'Petite apostrophe',
	'textResponsiveStyle': 'Dimensionnement automatique',
	'textAutoFontSize': 'Automatique',
	'textFontFamilySubClassHairline': 'Trait fin',
	'textFontFamilySubClassThin': 'Fin',
	'textFontFamilySubClassThinItalic': 'Italique fin',
	'textFontFamilySubClassExtraLight': 'Extra-fin',
	'textFontFamilySubClassExtraLightItalic': 'Italique extra-fin',
	'textFontFamilySubClassLight': 'Fin',
	'textFontFamilySubClassLightItalic': 'Italique fin',
	'textFontFamilySubClassRegular': 'Ordinaire',
	'textFontFamilySubClassRegularItalic': 'Italique ordinaire',
	'textFontFamilySubClassItalic': 'Italique',
	'textFontFamilySubClassMedium': 'Moyen',
	'textFontFamilySubClassMediumItalic': 'Italique moyen',
	'textFontFamilySubClassHeavy': 'Epais',
	'textFontFamilySubClassHeavyItalic': 'Italique épais',
	'textFontFamilySubClassDemiBold': 'Demi-gras',
	'textFontFamilySubClassDemiBoldItalic': 'Italique demi-gras',
	'textFontFamilySubClassBold': 'Gras',
	'textFontFamilySubClassBoldItalic': 'Italique gras',
	'textFontFamilySubClassExtraBold': 'Extra-gras',
	'textFontFamilySubClassExtraBoldItalic': 'Italique extra-gras',
	'textFontFamilySubClassBlack': 'Noir',
	'textFontFamilySubClassBlackItalic': 'Italique noir',
	'textFontFamilySubClassStencil': 'Stencil',
	'responsiveCoachmarkTitle': 'Dimensionnement de police automatique',
	'responsiveCoachmarkContents': 'La taille de police s\'adapte automatiquement lorsque vous redimensionnez ce type de texte. Vous pouvez définir la taille de police dans les propriétés du texte.',

	'propText': 'Détails du texte',
	'propTextReturn': 'Propriétés du texte',

	'textFontSize': 'Taille de la police',
	'textFontFamily': 'Famille de polices',
	'textFontWeight': 'Poids de la police',

	// Widget Properties
	'propImageLink': 'Lien vers l\'image',
	'propMissingURL': 'Entrer une adresse URL',
	'propImgTop': 'Propriétés des images',
	'propGeneralReturn': 'Propriétés générales',
	'propStyle': 'Général',
	'propStyleReturn': 'Général',
	'propFillColor': 'Couleur de remplissage',
	'propTextColor': 'Couleur du texte',
	'propBorderColor': 'Couleur de la bordure',
	'propMaintainAxisScales': 'Maintenir l\'échelle de l\'axe',
	'propShowItemLabel': 'Afficher le libellé de l\'élément',
	'propHideLegend': 'Masquer la légende',
	'propColorPalette': 'Palette',
	'propLegendPosition': 'Position de la légende',
	'propHideAxisTitleLabels': 'Masquer les titres des axes',
	'propLineColor': 'Couleur du trait',
	'propBubbleColor': 'Couleur de bulle',
	'propInterpolation': 'Courbes lisses',
	'propElementColor': 'Couleur de l\'élément de la visualisation',
	'propSymbolShape': 'Forme du symbole',
	'propHeatScalePalette': 'Ordre des couleurs',
	'propHeatScalePalette_tooltipDarkerForLowerValue': 'Les couleurs plus sombres représentent les plus petites valeurs.',
	'propHeatScalePalette_tooltipDarkerForHigherValue': 'Les couleurs plus sombres représentent les plus grandes valeurs.',
	'propImageDetails': 'Détails de l\'image',
	'propWebDetails': 'Détails de la page Web',
	'propMediaDetails': 'Détails du support',
	'propPasteLink': 'Saisissez l\'URL et appuyez sur Entrée',

	//Layout Properties
	'propPositionLabel': 'Position',
	'propPositionXAxis': 'X',
	'propPositionYAxis': 'Y',
	'propResizeLabel': 'Taille',
	'propResizeWidth': 'Largeur',
	'propResizeHeight': 'Hauteur',
	'propRotateLabel': 'Pivoter',
	'propRotateAngle': 'Angle',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'Nombre d\'icônes',
	'propScaleDescription': 'Sélectionnez le nombre d\'icônes',
	'propScaleFew': 'Faible',
	'propScaleDefault': 'Par défaut',
	'propScaleMany': 'Elevé',

	'mediaAriaLabel': 'Entrée d\'URL',
	'ariaGroupLabel': 'Catégorie de liste déroulante : %{cateoryLabel} élément : %{itemLabel}. Appuyez sur la touche Vers le bas pour développer. Appuyez sur les touches Vers le haut et Vers le bas pour naviguer, ou sur la touche Echap pour réduire.',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': 'Dernière actualisation : il y a %{timeInterval}',
	'widgetTimer': 'Temporisateur de widget',

	// Theme colors
	'transparent': 'Sans couleur',
	'white': 'Blanc',
	'lightGrey': 'Gris clair',
	'grey': 'Gris',
	'darkGrey': 'Gris foncé',
	'black': 'Noir',
	'lightBlue': 'Bleu clair',
	'blue': 'Bleu',
	'darkBlue': 'Bleu foncé',
	'yellow': 'Jaune',
	'orange': 'Orange',
	'lime': 'Vert printemps',
	'green': 'Vert',
	'peach': 'Pêche',
	'red': 'Rouge',
	'violet': 'Violet',
	'aqua': 'Cyan',
	'purple': 'Violet',
	'plum': 'Prune',

	//Theme Palette Label
	'paletteLabel': 'Palette IBM %{number}',
	'heatPaletteLabel': 'Palette de densités IBM %{number}',
	'conditionalPaletteLabel': 'Palette conditionnelle IBM %{number}',
	'userPaletteColor_lightTheme': 'Palette légère IBM',
	'userPaletteColor_defaultTheme': 'Palette par défaut IBM',
	'userPaletteColor_darkTheme': 'Palette sombre IBM',

	// Dashboard
	'propDashboardBackgroundColor': 'Couleur d\'arrière-plan',
	'dataCache': 'Cache de données',
	'dataCache_on': 'Activé',
	'dataCache_off': 'Aucune mémoire cache',
	'dataCache_auto': 'Automatique',
	'propLayoutPositioning': 'Positionnement de la présentation',
	'propLayoutRelative': 'Relatif',
	'propLayoutAbsolute': 'Absolu',
	'propLayoutPositioningCoachmarkTitle': 'Sélectionner un style de présentation',
	'propLayoutPositioningCoachmarkContent': 'Dans une présentation relative, la taille et la position des widgets s\'ajustent à l\'écran. Les widgets avec une présentation absolue apparaissent avec la taille et à l\'endroit que vous avez choisis dans la vue, quelle que soit la taille de l\'écran.',
	'gridText': 'Afficher la grille',
	'snapText': 'Aligner sur la grille',
	'snapObjectsText': 'Aligner aux objets',
	'fitPageText': 'Adapter à la page',
	'gridLabel': 'Grille',
	'heightUnit': 'h',
	'widthUnit': 'l',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'Taille de page',
	'propPageSizePresetAriaLabel': 'Taille de page prédéfinie',
	'propPageSizePreset': 'Prédéfinie',
	'propPageSizePresetCustom': 'Personnalisé',
	'propPageSizePreset16x9': 'Ecran 16:9',
	'propPageSizePreset4x3': 'Ecran 4:3',
	'propPageSizePresetInfographic': 'Infographie',
	'propPageSizeWidth': 'Largeur',
	'propPageSizeHeight': 'Hauteur',
	'propPageSizeWidthAriaLabel': 'Largeur de la taille de page',
	'propPageSizeHeightAriaLabel': 'Hauteur de la taille de page',
	'propPageSizeAdjustedMessage': 'La taille de page a été augmentée car votre entrée était inférieure à la taille minimale ou n\'était pas adaptée à votre tableau de bord.',
	'propTabShow': 'Afficher les onglets',
	'propShowTabsInPreview': 'Afficher les onglets dans l\'aperçu',
	'multilingualDashboardsLabel': 'Langues',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- Par défaut',
	'multilingualDashboardsAddLinkText': 'Ajouter une autre langue',
	'multilingualDashboardsSelect': 'Sélectionner',
	'multilingualDashboardsButtonLabel': 'Ajouter',
	'multilingualDashboardTranslationMode': 'Vous êtes maintenant en mode traduction (%{currentLanguage})',
	'multilingualDashboardTranslationDone': 'Terminé',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} traductions restantes',
	'multilingualDashboardRemainingString': '1 traduction restante',
	'multilingualDashboardsSetDefault': 'Définir la langue par défaut',
	'multilingualDashboardIconMore': 'Autres actions pour la langue %{currentLanguage}',
	'multilingualDashboardIconTranslatableArea': 'Zone traduisible',
	'multilingualDeleteTitle': 'Supprimer la langue',
	'multilingualDeleteLanguageWarning': 'Voulez-vous vraiment supprimer la langue \'%{language}\' ?',
	'multilingualSelectLanguage': 'Sélectionnez une langue',
	'confirmLayoutStyleUpgradeTitle': 'Appliquer à tous les onglets',
	'confirmLayoutStyleUpgrade': 'Appliquer ce style de présentation à tous les onglets de votre tableau de bord ?',

	//Tabs
	'tabDeleteDialogYesButton': 'Oui',
	'tabDeleteDialogNoButton': 'Non',
	'tabDeleteDialogTitle': 'Supprimer cet onglet ?',
	'tabDeleteDialogMessage': 'Tout le contenu de cet onglet sera également supprimé.',

	// Vis widget
	'propVisTypeReturn': 'Types de visualisation',
	'propVisDetails': 'Détails',

	// Alignment picker
	'propAlignPickTop': 'Aligner en haut',
	'propAlignPickRight': 'Aligner à droite',
	'propAlignPickBottom': 'Aligner en bas',
	'propAlignPickLeft': 'Aligner à gauche',
	'propAlignPickCenter': 'Aligner au centre',
	'propAlignPicker': 'Alignement',

	// Toolbar picker
	'propToolbarPickBold': 'Gras',
	'propToolbarPickUnderline': 'Soulignement',
	'propToolbarPickItalic': 'Italique',
	'propToolbarPickJustifyLeft': 'Aligner à gauche',
	'propToolbarPickJustifyCenter': 'Aligner au centre',
	'propToolbarPickJustifyRight': 'Aligner à droite',
	'propToolbarPickJustify': 'Justifier',

	'propList': 'Liste',
	'propOrderedList': 'Liste numérotée',
	'propUnorderedList': 'Liste non numérotée',

	// Symbol shapes
	'propCircle': 'Cercle',
	'propTriangle': 'Triangle',
	'propSquare': 'Carré',
	'propRect': 'Rectangle',
	'propStar': 'Etoile',
	'propCross': 'Croix',
	'propPlus': 'Signe Plus',
	'propPoly': 'Polygone',


	// True and false selection
	'propTrue': 'Vrai',
	'propFalse': 'Faux',

	// Position selection
	'propLeft': 'A gauche',
	'propRight': 'A droite',
	'propTop': 'En haut',
	'propBottom': 'En bas',

	// Interpolation options
	'propSmooth': 'Lisse',
	'propStraight': 'Droite',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'Liste', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': 'Vers la gauche', // screen reader
	'srWidgetMoveUp': 'Vers le haut', // screen reader
	'srWidgetMoveRight': 'Vers la droite', // screen reader
	'srWidgetMoveDown': 'Vers le bas', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'Agrandir proportionnellement', // screen reader
	'srWidgetResizeSmaller': 'Réduire proportionnellement', // screen reader
	'srWidgetResizeBiggerV': 'Agrandir verticalement', // screen reader
	'srWidgetResizeSmallerV': 'Réduire verticalement', // screen reader
	'srWidgetResizeBiggerH': 'Agrandir horizontalement', // screen reader
	'srWidgetResizeSmallerH': 'Réduire horizontalement', // screen reader

	// widget rotate
	'srWidgetRotateCW': 'Rotation sens horaire', // screen reader
	'srWidgetRotateCCW': 'Rotation sens anti-horaire', // screen reader

	// Recommended types
	'visChange': 'Changer de visualisation',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': 'Visualisation',
	'chartLabel': 'Graphique %{chartName}',
	'dataWidgetDescription': '%{widgetLabel} : %{columnNames}',
	'f12KeyDescription': 'Appuyez sur F12 pour naviguer à l\'intérieur du widget',
	'f10KeyDescription': 'Appuyez sur F10 pour lancer la vue de mise en évidence du widget',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} avec la valeur %{value}',

	'shapeColorLabel': 'Couleur de la forme',
	'showLegendLabel': 'Afficher la légende',

	//Webpage
	'webpageWidgetTitle': 'Widget de page Web',
	'webpagePasteLink': 'Coller l\'URL et appuyer sur Entrée pour l\'enregistrer',
	'propWebpageLink': 'URL de la page Web',
	'propWebpageTitle': 'Titre de la page Web',
	'propWebpageTitleDescription': 'Titre de la page Web',
	'propWebpageTop': 'Propriétés de la page Web',
	'webpageMissingUrl': 'L\'URL de la page Web est manquante',
	'webpageUrlValidationError': 'L\'URL de la page Web n\'est pas valide',
	'webpageHttpValidationError': 'Le navigateur n\'affiche la page Web que si vous y accédez par un lien HTTPS',
	'webpageInvalidDomainError': 'L\'URL de la page Web pointe vers un domaine qui n\'a pas été approuvé par votre administrateur. Les domaines approuvés par votre administrateur sont "%{domains}"',

	//VizState
	'vzErrorLoading': 'Impossible de charger la visualisation',
	'vzErrorLoadingMissingData': 'Impossible de charger la visualisation, données contextuelles manquantes',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'Widget multimédia',
	'mediaPasteLink': 'Coller l\'URL et appuyer sur Entrée pour l\'enregistrer',
	'videoHeight': 'Hauteur :',
	'videoWidth': 'Largeur :',
	'propMediaLink': 'Lien du support',
	'propMediaTitle': 'Titre du support',
	'propMediaTitleDescription': 'Titre du support',
	'propMediaTop': 'Propriétés du support',
	'mediaMissingUrl': 'L\'URL du lien du support est manquante',
	'mediaUrlValidationError': 'L\'URL du fichier du support n\'est pas valide',
	'mediaUnknownValidationError': 'Ce type de support n\'est pas pris en charge',
	'mediaHttpValidationError': 'Le navigateur n\'affiche le fichier du support que si vous y accédez par un lien HTTPS',
	'mediaInvalidDomainError': 'L\'URL du fichier de support pointe vers un domaine qui n\'a pas été approuvé par votre administrateur. Les domaines approuvés par votre administrateur sont "%{domains}"',

	// Properties pane
	'commonPropertiesLabel': 'Propriétés',

	// Data strip
	'dataSetsLabel': 'Ensemble de données',
	'dataViewsLabel': 'Vue',
	'columnQuality': 'Qualité des données',
	'columnProperties': 'Propriétés des données',

	'dataQuality': 'Qualité des données',
	'dataQualityRowCount': 'Nombre de lignes',
	'dataQualityDistribution': 'Distribution',
	'dataRowLabel': 'Données',

	// Modelling UI
	'typeColumn': 'Type',
	'modellingColumnType': 'Type',
	'modellingColumnAggregation': 'Agrégation',
	'modellingColumnUsage': 'Utilisation',
	'modellingColumnSort': 'Trier',
	'modellingColumnFormat': 'Format',
	'modellingColumnCategory': 'Catégorie',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'Chargement...',

	'modellingProcessing': 'Traitement...',
	'modellingImport': 'Importation',
	'modellingReimport': 'Réimportation',
	'modellingDatasourceTitle': 'Source de données',
	'modellingImportStartedTitle': 'Importation commencée',
	'modellingImportStartedText': 'L\'importation de vos données peut durer un certain temps.\n\n(Vous pouvez créer une vue pendant cette opération.)',
	'importDatasourceTitle': 'Connexions',
	'dropHere': 'Faites glisser des éléments ici pour créer une nouvelle source de données...',
	'browseButton': 'Parcourir',
	'errorNoData': 'Il n\'y a pas de donnée à traiter.',
	'errorNoFile': 'Il n\'y a pas de fichier à transférer.',
	'errorUploadFailed': 'Impossible d\'envoyer par transfert.',
	'uploadSucceessful': 'Le transfert a abouti',
	'del_datasourceTitle': 'Supprimer l\'ensemble de données',
	'del_datasourceMsg': 'Voulez-vous vraiment supprimer \'%{name}\' ?',
	'modellingFileUpdate': 'Mettre à jour',
	'modellingFileUpdateTitle': 'Mettre à jour l\'ensemble de données',
	'modellingFileUpdateDescription': 'Voulez-vous mettre à jour de \'%{name}\'?',
	'modellingFileUpdatingTitle': 'Mise à jour de \'%{name}\'',
	'modellingUpdateStartedTitle': 'L\'importation de la mise à jour a commencé',
	'modellingUpdateStartedText': 'La mise à jour de vos données peut durer un certain temps.\n\n(Vous pouvez créer une vue pendant cette opération.)',
	'modellingErrorImportUploadNoFile': 'Aucun fichier à transférer.',
	'modellingErrorImportUploadFailed': 'Impossible d\'envoyer par transfert.',
	'modellingErrorImportUploadInvalidType': 'Le type de fichier n\'est pas valide.',
	'modellingErrorImportUploadTableFailed': 'Impossible d\'obtenir les tables.',
	'modellingIntentResultsTitle': 'Sélectionner l\'ensemble de données proposé à utiliser',
	'modellingColumnViewRelationships': 'Tables associées à la vue',
	'modellingTableRelatedTables': 'Tables associées à \'%{name}\'',
	'modellingTable': '%{name} - Table',
	'modellingColumnIncludedInDataSet': 'Ajouté',
	'modellingDataSet': 'Ensemble de données',
	'modellingViewInDataSet': 'Afficher dans l\'ensemble de données',
	'modellingViewRelatedTables': 'Afficher associés',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': 'Aucune table associée n\'a été trouvée',

	'modellingValidatingDataset': 'Validation...',
	'datasetFinishedRefreshing': 'L\'ensemble de données %{datasetName} a été actualisé.',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': 'Résoudre le chemin de jointure :',
	'modellingJoinColumns': 'Définir un chemin de jointure pour la table : %{name}',
	'modellingJoinToTable': 'Joindre à la table : %{name}',

	// Data Quality
	'excluded': 'Exclu(e)',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'Mn',
	'metricPrefixBillion': 'o',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'Filtre',
	'modellingColumnSortNone': 'Effacer le tri',
	'modellingColumnSortAsc': 'Trier par ordre croissant',
	'modellingColumnSortDesc': 'Trier par ordre décroissant',
	'modellingColumnRemove': 'Retirer cette colonne',

	// Import File Browser
	'dropboxPageTitle': 'Nouvelle connexion de boîte de dépôt',
	'sizeColumn': 'Taille',

	//Modelling Column Property Values
	'dataType_string': 'Chaîne',
	'dataType_date': 'Date',
	'dataType_integer': 'Entier',
	'dataType_double': 'Double',
	'dataType_float': 'Flottant',
	'dataType_boolean': 'Booléen',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': 'Nombre',
	'defaultAggregation_countdistinct': 'Nombre (éléments distincts)',
	'defaultAggregation_max': 'Maximum',
	'defaultAggregation_min': 'Minimum',
	'defaultAggregation_avg': 'Moyenne',
	'defaultAggregation_sum': 'Somme',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',

	'type_fact': 'Fait',
	'type_attribute': 'Attribut',

	'defaultSort_none': 'Ne pas trier',
	'defaultSort_asc': 'Trier par ordre croissant',
	'defaultSort_desc': 'Trier par ordre décroissant',

	'category_none': 'Aucun',
	'category_location': 'Emplacement',
	'category_monetary': 'Valeur monétaire',
	'category_time': 'Heure',

	// Root menu
	'rootMenuTitle': 'Menu principal',

	'errorMessageTitle': 'Erreur',
	'errorMessageDetails': 'Détails : ',
	'errorMessageTitleAssetAlreadyExists': 'Cet actif existe déjà',

	'defaultTabTitle': 'Onglet %{index}',
	'tabAddBtnTitle': 'Ajouter un nouvel onglet',

	'unsupportedConditionalFormattingEncountered': 'Le formatage conditionnel n\'est plus appliqué à certaines colonnes.',


	// Homepage View
	'nameColumn': 'Nom',
	'creatorColumn': 'Créé par',
	'creationDateColumn': 'Date de création',
	'versionColumn': 'Version',
	'modifiedColumn': 'Dernière modification',

	'filterBy': 'Filtrer les éléments',
	'allFilter': 'Tous les éléments',
	'createdByMeFilter': 'Créés par moi',
	'sharedWithMeFilter': 'Partagés avec moi',
	'favoritesFilter': 'Mes favoris',
	'recentsFilter': 'Ajoutés récemment',
	'sortBy': 'Trier par',

	// Sort Menu
	'sortModified': 'Modifié',
	'sortUpdated': 'Mis à jour',
	'sortName': 'Nom',

	'viewAs': 'Afficher sous forme de',
	'thumbnailsView': 'Afficher les miniatures',
	'listView': 'Afficher la liste',
	'createMenu': 'Créer',
	'newAppItem': 'Tableau de bord',
	'newDataSet': 'Ensemble de données',

	'menuSelectionState_a11y': 'Sélecteur "%{item}" défini sur "%{selectedItem}"',

	'unableToShareItem': 'Impossible de partager l\'article "%{item}".',
	'toastFetchingContent': 'Extraction de contenu supplémentaire...',
	'unableToGetData': 'Impossible d\'obtenir le contenu.',
	'unableToFavorite': 'Impossible de modifier le statut Favori.',
	'hpErrorMissingRequiredOptions': 'Des options d\'initialisation requises sont manquantes',
	'unableToOpenBoard': 'Impossible d\'ouvrir "%{name}".',
	'unableToDuplicateBoard': 'Impossible de dupliquer "%{name}".',
	'unableToCreateBoard': 'Impossible de créer "%{name}".',
	'unableToCreateBoardNameConflict': 'Un actif de ce nom existe déjà.',

	// DataSet Detail View
	'status': 'Statut',
	'numberOfRows': 'Lignes',
	'importWarnings': 'Avertissements',
	'lineNumbers': 'Courbes',
	'excerptFromSource': 'Extrait',
	'reason': 'Raison',
	'numberOfRowsDropped': 'lignes supprimées',
	'oneRowDropped': '1 ligne a été supprimée',

	// Type Menu
	'typeMenuLabel': 'Type',
	'dashboardsLabel': 'Tableaux de bord',
	'datasetsLabel': 'Ensembles de données',
	'storiesLabel': 'Histoires',
	'allLabel': 'Tous les types',

	// Board Page View App Bar
	'datasets': 'Ensembles de données',
	'settings': 'Propriétés',
	'add': 'Ajouter',
	'widgets': 'Widgets',
	'dashboardProperties': 'Propriétés du tableau de bord',
	'pins': 'Collection',
	'pinsOld': 'Mes épingles',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} épingle |||| %{smart_count} épingles',
	'pinSearch': 'Rechercher',
	'pinSearchOld': 'Rechercher des épingles',
	'pinListView': 'Vue de liste',
	'pinIconView': 'Vue d\'icônes',
	'pinRemove': 'Retirer',
	'pinCreate': 'Créer',
	'pinDeleteError': 'Un ou plusieurs actifs ne peuvent pas être supprimés de la collection. Réessayez ultérieurement.',
	'pinDeleteErrorOld': 'Une ou plusieurs épingles ne peuvent pas être supprimées. Réessayez ultérieurement.',
	'pinRetrieveError': 'Une ou plusieurs épingles ne peuvent pas être extraites. Réessayez ultérieurement.',
	'NoPinsCollected': 'Aucune visualisation épinglée',
	'pinDeletedToast': 'L\'épingle a été supprimée',
	'pinAddedToast': 'L\'épingle a été ajoutée à Mes épingles',
	'pinningToast': 'Traitement de l\'épingle...',
	'pinDateFilter': 'Filtre de date',
	'pinDateFilterAll': 'Toutes',
	'pinDateFilterToday': 'Aujourd\'hui',
	'pinDateFilterYesterday': 'Hier',
	'pinDateFilterPastWeek': 'Semaine dernière',
	'pinDateFilterPastMonth': 'Mois dernier',
	'pinDateFilterEarlier': 'Avant',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'Editer le titre',
	'toolbarActionSort': 'Trier',
	'toolbarActionSortAscending': 'Trier par ordre croissant',
	'toolbarActionSortDescending': 'Trier par ordre décroissant',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionFormat': 'Format',
	'toolbarActionFormatAbbreviation': 'Abréger',
	'toolbarActionFormatNone': 'Automatique',
	'toolbarActionFilter': 'Filtre',
	'toolbarActionTopBottom': 'Premier ou dernier',
	'toolbarActionAddShape': 'Ajouter une forme',
	'toolbarActionRmvShape': 'Retirer une forme',
	'toolbarActionToggleShapeDrop': 'Forme de l\'infographique',
	'toolbarActionToggleShapeDropTitle': 'Création d\'infographie',
	'toolbarActionToggleShapeDropText': 'Faites glisser une forme dans cette zone pour créer une infographie.',
	'toolbarActionAggregationType': 'Récapituler',
	'toolbarDeleteActionText': 'Retirer la colonne',
	'toolbarActionFilterLocalKeepSelected': 'Conserver',
	'toolbarActionFilterLocalExcludeSelected': 'Exclure',
	'toolbarActionFilterAllKeepSelected': 'Filtre',
	'toolbarActionSimpleCalculation': 'Calcul simple',
	'toolbarActionDrillBack': 'Précédent',
	'toolbarActionDrillUp': 'Passer au niveau supérieur',
	'toolbarActionDrillDown': 'Passer au niveau inférieur',
	'toolbarActionNavigate': 'Naviguer',
	'toolbarActionCreateFilterGroup': 'Créer une connexion',
	'toolbarActionDisconnectFilterGroup': 'Rompre tous les liens',
	'toolbarActionLinkFilterGroup': 'Ajouter à une connexion existante',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': 'Ajouter',
	'sidebarMultiselect': 'Activer/désactiver la sélection multiple',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} sélectionné',

	'multiselectWithTotalMsg': '%{count} sur %{total}',
	'sidebarGoBack': 'Revenir en arrière',

	//DataSet pane
	'errorLoadingDataSets': 'Impossible de charger cet ensemble de données',
	'errorLoadingDataSetMetaData': 'Impossible de charger cet ensemble de données',
	'dataSetPaneLastUpdated': 'Dernière mise à jour : %{date}',
	'dataSetPaneDateUnknown': 'Inconnu',
	'sourcePaneLabel': 'Sources sélectionnées',
	'addSourceLabel': 'Ajouter une source',
	'find_label': 'Rechercher',
	'navigationPathsLabel': 'Chemins de navigation',

	//widgetlist
	'errorLoadingWidgetList': 'Impossible de charger les objets',
	'errorLoadingThemeFile': 'Impossible de charger la définition du thème.',
	'errorLoadingLayoutFile': 'Impossible de charger la vue.',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': 'Impossible de charger les définitions de visualisation disponibles.',

	'dwErrorLoadingVisualizationNotFound': 'Impossible de charger l\'objet, car il lui manque une définition de visualisation.',
	'dwErrorLoadingVisualizationListNotFound': 'Impossible de charger la visualisation.',
	'dwErrorRunningQuery': 'Impossible d\'extraire les données de l\'ensemble de données %{datasetName}.',
	'dwErrorGeoData': 'L\'affichage des données géographiques dans une carte ne fonctionne pas bien. Veuillez choisir un autre type de visualisation. ',
	'dwPromptSignonCancelWarning': 'Les données pour cette visualisation ne sont pas disponibles. Indiquez les données d\'identification appropriées.',
	'dwErrorMissingDataset': 'Impossible de charger la visualisation car l\'ensemble de données \'%{datasetName}\' qui lui est associé n\'est pas disponible.',
	'dwErrorRenderingVisualization': 'Impossible de charger cette visualisation.',
	'dwErrorVisualizationTooSmall': 'La visualisation est trop petite pour afficher les données qu\'elle contient. Agrandissez la visualisation ou réduisez les données qu\'elle contient.',
	'aria_label_datatable': 'Table de données',
	'aria_key_navi_datatable_desc': 'Utilisez les touches de déplacement du curseur pour naviguer entre les cellules. Appuyez sur les touches Ctrl et Position init. pour passer à la première ligne, et sur les touches Ctrl et Fin pour passer à la dernière ligne.',
	'geomapUnrecognizedLocations': 'Emplacements non reconnus :',
	'geomapAmbiguousLocations': 'Régions ambiguës :',

	// custom widget
	'customWidget': 'Widget personnalisé',
	'noCustomWidgets': 'Aucun widget personnalisé',

	// Action names
	'toggleContextBar': 'Activer/désactiver la barre de contexte',
	'delete': 'Supprimer',
	'share': 'Partager',
	'unshare': 'Annuler le partage',
	'rename': 'Renommer',
	'close': 'Fermer',
	'duplicate': 'Dupliquer',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': 'Réessayer',

	'changeTemplate': 'Changer le modèle',

	// Aggregation Types
	'sum': 'Somme',
	'count': 'Nombre',
	'countdistinct': 'Nombre (éléments distincts)',
	'avg': 'Moyenne',
	'min': 'Minimum',
	'max': 'Maximum',
	'custom': 'Personnalisé',
	'calculated': 'Valeur calculée',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '% de modification',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': 'Critères de visualisation...',
	'QuickAddResultsHeader': 'Visualisation des données',
	'NoQuickAddResults': 'Il n\'y a pas de correspondances pour votre centre d\'intérêt. Voulez-vous créer un nouvel ensemble de données ?',
	'NoQuickAddResultsRetry': 'Impossible de trouver des correspondances. Essayez avec d\'autres termes.',
	'templateWidgetTitle': 'Modèle',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(blanc)',

	'nullValueContent': '(pas de valeur)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'Filtre de texte - %{columnName}',

	'textFilterSelectTab': 'Sélectionner',

	'textFilterConditionTab': 'Définir une condition',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': 'Aucun élément n\'est disponible.',

	'textFilterEquals': 'Egal à',
	'textFilterContains': 'Contient',
	'textFilterBeginsWith': 'Commence par',
	'textFilterEndsWith': 'Se termine par',
	'textFilterDoesNotEqual': 'N\'est pas égal(e) à',
	'textFilterDoesNotContain': 'Ne contient pas',
	'textFilterDoesNotBeginWith': 'Ne commence pas par',
	'textFilterDoesNotEndWith': 'Ne se termine pas par',
	'textFilterSampleText': 'Par exemple : A',

	'textFilterAndButton': 'Et',
	'textFilterOrButton': 'Ou',

	'dateFilterMessage': 'Sélectionnez un éventail de dates',
	'dateRangeControlRegionLabel': 'Filtre de plage de dates - %{columnName}',
	'dateFilterRangeOption': 'Option de plage',
	'dateFilterDateLabel': 'Date',
	'dateFilterBlank': '(blanc)',
	'dateFilterBefore': 'Avant',
	'dateFilterAfter': 'Après',
	'dateFilterBetween': 'Entre',
	'dateFilterSampleText': 'AAAA-MM-JJ',
	'dateTitle': 'Date',
	'dateIncludeBlankLabel': 'Inclure une date vierge',

	'timeTitle': 'Heure',
	'timeFilterMessage': 'Sélectionnez une plage d\'heures',
	'dateTimeFilterMessage': 'Sélectionnez une plage de dates et d\'heures',

	'topbottomNumberOfResultsLabel': 'Nombre de résultats',
	'topbottomPercentLabel': 'Pourcentage',
	'topbottomNumberOfResultsLimit': 'Entre %{lower} et %{higher}',
	'topbottomSelectOption': 'Option Premier ou dernier',
	'topbottomOptionLabel': 'Afficher',
	'searchByLabel': 'Par',
	'searchNoMatches': 'Aucun résultat trouvé',
	'topbottomRankColumnLabel': 'Ajouter une colonne de classement à la table',
	'topbottomNone': 'Aucun',
	'topCount': 'Nombre le plus élevé',
	'topPercent': 'Premiers %',
	'bottomCount': 'Nombre le plus bas',
	'bottomPercent': 'Derniers %',
	'topbottomSearchColumn': 'Rechercher une colonne',
	'searchColumnAriaLabel': 'Recherchez une colonne. Entrez le nom de la colonne à rechercher, puis utilisez la flèche vers le bas pour rechercher la colonne dans une liste.',
	'rankColumnLabel': 'Rang (%{columnLabel})',
	'topbottomClearLabel': 'Effacer',

	'rangeFilterControlRegionLabel': 'Filtre de plage - %{columnName}',

	// Slider
	'sliderRegionLabel': 'Curseur, utilisez les flèches vers la droite et vers la gauche pour déplacer les poignées du curseur',
	'sliderHandleLabel': 'Poignée du curseur',
	'a11ySliderHandleLabel': 'Poignée du curseur %{sliderValue}',
	'sliderInputLabel': 'valeur',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'Certains éléments de l\'ensemble de données utilisés dans cette visualisation sont indisponibles.',
	'datasetItemUnavailable': 'Cet élément d\'ensemble de données n\'est pas disponible',

	//Authoring topBottom
	'topOperator': 'En haut',
	'bottomOperator': 'En bas',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{value} %{operator} par %{columnLabel}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{value} %{operator}',
	'topBottomTitle': 'Cet objet uniquement',
	'deleteTopBottom': 'Supprimer le nombre de premiers ou de derniers',
	'editTopBottom': 'Editer le nombre de premiers ou de derniers',
	'deleteDrillState': 'Supprimer l\'état d\'exploration en cours',
	'ariaDeleteDrillStateLabel': 'Appuyez sur la touche ENTREE pour éditer le nombre de premiers ou de derniers.',
	'drillUpStateTitle': 'Passer au niveau supérieur',
	'drillDownStateTitle': 'Passer au niveau inférieur',
	'ariaEditTopBottomLabel': 'Appuyez sur la touche ENTREE pour éditer le nombre de premiers ou de derniers.',
	'ariaDeleteTopBottomLabel': 'Appuyez sur la touche SUPPR pour supprimer le nombre de premiers ou de derniers.',

	// Authoring filtering
	'dimFilterIn': 'Inclut : %{in}',
	'dimFilterNotIn': 'Exclut : %{out}',
	'measureFilterBetween': 'Entre %{lowerBound} et %{upperBound}',
	'measureFilterNotBetween': 'Pas entre %{lowerBound} et %{upperBound}',
	'gtFilter': 'Après %{lowerBound}',
	'ltFilter': 'Avant %{upperBound}',
	'notGtFilter': 'Pas après %{lowerBound}',
	'notLtFilter': 'Pas avant %{upperBound}',
	'localFilterTitle': 'Cet objet uniquement',
	'globalFilterTitle': 'Tous les objets',
	'deleteFilter': 'Supprimer le filtre',
	'editFilter': 'Editer le filtre',
	'ariaEditFilterLabel': 'Appuyez sur la touche Entrée pour éditer le filtre.',
	'ariaDeleteFilterLabel': 'Appuyez sur la touche Suppr pour supprimer le filtre.',

	// Prompts
	'ariaEditPrompt': 'Appuyez sur la touche Entrée pour changer la valeur d\'invite',

	'moreDataIndicator': 'Vos données ont été tronquées à %{threshold} éléments. Appliquez un filtre pour en afficher moins.',

	// data point filtering
	'dataPointFilterTitle': 'Points de données',
	'dataPointFilterIncludeSummary': 'Points de données %{valueCount} inclus',
	'dataPointFilterExcludeSummary': 'Points de données %{valueCount} exclus',

	// DB2 connection page
	'db2Database': 'Base de données DB2 (%{jdbcConnection})',
	'db2Title': 'Connexion à IBM DB2',

	// Database
	'databaseConnectionMessage': 'Renseignez les détails de connexion à votre base de données :',
	'connectionString': 'Chaîne de connexion à la base de données',
	'databaseCredentials': 'Données d\'identification : ',
	'databaseUserName': 'Nom d\'utilisateur',
	'databasePassword': 'Mot de passe',
	'databaseConnect': 'Connexion',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': 'Entrez un terme de recherche :',
	'twitterKeyword': 'Mot clé',
	'twitterSearch': 'Rechercher',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Boîte de dépôt',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'Création de la vue impossible : %{error}\nEchec de l\'opération : %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'Filtres de widget',
	'missingColumn': 'Manquant : %{columnLabel}',
	'missingFiltering': 'Filtres manquants pour les ID de colonne suivants :',
	'heatByLabel': 'Densité selon',
	'evColumns': 'Colonnes',
	'evLocalFilters': 'Filtres locaux',
	'evExpand': 'Développer',
	'evFilterTooltip': 'Filtre',
	'evAdd': 'Ajouter une colonne',

	// Navigation View
	'navigationBack': 'Précédent',

	// Pinning
	'contentPinFail': 'Impossible de collecter le contenu. Réessayez ultérieurement.',
	'contentPinFailOld': 'Impossible d\'épingler le contenu. Réessayez ultérieurement.',

	// Layouts
	'dropZoneLabel': 'Déposer ici pour agrandir',

	//Share
	'shareDefaultPageTitle': 'Page %{index}',

	'nextPage': 'Page suivante',
	'previousPage': 'Page précédente',

	'assetAssembly': 'vue',

	'toolbar_save': 'Enregistrer',
	'brgr_saveAs': 'Enregistrer sous',
	'brgr_refresh': 'Actualiser',

	// Save
	'saving': 'Enregistrement...',
	'save_success': 'Votre vue a été sauvegardée.',
	'save_failure': 'Désolé. Votre vue n\'a pas pu être sauvegardée. Veuillez réessayer ultérieurement.',
	'dashboard_save_success': 'Votre tableau de bord a été sauvegardé.',

	'geminiLeave': 'Vous êtes sur le point de quitter IBM Watson Analytics.',

	'warning': 'Avertissement',
	'missingDataSetData': 'Les données de cet ensemble de données ne sont pas disponibles. Actualisez l\'ensemble de données ou prenez contact avec votre administrateur pour accéder à la source.',

	// Calculations
	'error_calculation_in_use': 'Le calcul sélectionné est en cours d\'utilisation et ne peut pas être supprimé.',

	'resize': 'Redimensionner',
	'rotate': 'Pivoter',
	'moveHandle': 'Déplacer le widget',
	'expandHandle': 'Développer',
	'panHandle': 'Panoramique',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'Accès à',

	// Slide out titles
	'shapeSlideoutTitle': 'Formes',
	'textSlideoutTitle': 'Texte',
	'mediaSlideoutTitle': 'Supports',
	'visualizationSlideoutTitle': 'Visualisations',

	// Board Model Dialog Messages
	'invalidJSONResponse': 'Le JSON fourni n\'est pas valide. Consultez le journal des erreurs pour plus d\'informations.',

	// Widget type labels
	'shape_label': 'Forme',
	'image_label': 'Image',
	'data_label': 'Graphique',
	'media_label': 'Supports',
	'text_label': 'Texte',
	'embedMedia_label': 'Supports',
	'youtube_label': 'Vidéo YouTube',
	'webpage_label': 'Page Web',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': 'Forme',
	'noExtraText_shape_numbered': 'Forme (%{number})',
	'few_shape': 'Groupe de %{count} formes',
	'many_shape': 'Groupe de %{count} formes',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': 'Image %{text}',
	'one_image_numbered': 'Image %{text} (%{number})',
	'noExtraText_image': 'Image',
	'noExtraText_image_numbered': 'Image (%{number})',
	'few_image': 'Groupe de %{count} images',
	'many_image': 'Groupe de %{count} images',
	'noExtraText_text': 'Zone de texte vide',
	'noExtraText_text_numbered': 'Zone de texte vide (%{number})',
	'few_text': 'Groupe de %{count} zones de texte',
	'many_text': 'Groupe de %{count} zones de texte',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} par %{row_level1} et %{column_level1} - tableau croisé',
	'crosstab_opt_mapping_numbered': '%{values} par %{row_level1} et %{column_level1} (%{number}) - tableau croisé',
	'crosstab_has_mapping': '%{values} par %{row_level1} - tableau croisé',
	'crosstab_has_mapping_numbered': '%{values} par %{row_level1} (%{number}) - tableau croisé',
	'crosstab_no_mapping': 'Tableau croisé vide',
	'crosstab_no_mapping_numbered': 'Tableau croisé vide (%{number})',
	'crosstab_named': 'Tableau croisé %{name}',
	'crosstab_named_numbered': 'Tableau croisé %{name} (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} - tableau',
	'JQGrid_has_mapping_numbered': '%{grid_cols} - tableau (%{number})',
	'JQGrid_no_mapping': 'Tableau vide',
	'JQGrid_no_mapping_numbered': 'Tableau vide (%{number})',
	'JQGrid_named': 'Tableau %{name}',
	'JQGrid_named_numbered': 'Tableau %{name} (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': 'Hiérarchie d\'%{level1}',
	'hierarchy_has_mapping_numbered': 'Hiérarchie d\'%{level1} (%{number})',
	'hierarchy_no_mapping': 'Hiérarchie vide',
	'hierarchy_no_mapping_numbered': 'Hiérarchie vide (%{number})',
	'hierarchy_named': 'Hiérarchie %{name}',
	'hierarchy_named_numbered': 'Hiérarchie %{name} (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': 'Mappe %{categories}',
	'map_has_mapping_numbered': 'Mappe %{categories} (%{number})',
	'map_no_mapping': 'Carte vide',
	'map_no_mapping_numbered': 'Carte vide (%{number})',
	'map_named': 'Mappe %{name}',
	'map_named_numbered': 'Mappe %{name} (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': 'Valeur récapitulative de %{actual}',
	'summary_has_mapping_numbered': 'Valeur récapitulative de %{actual} (%{number})',
	'summary_no_mapping': 'Valeur récapitulative vide',
	'summary_no_mapping_numbered': 'Valeur récapitulative vide (%{number})',
	'summary_named': 'Valeur récapitulative %{name}',
	'summary_named_numbered': 'Valeur récapitulative %{name} (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': 'Indicateur clé de performance de %{actual} par %{sparkline.time}',
	'kpi_opt_mapping_numbered': 'Indicateur clé de performance de %{actual} par %{sparkline.time} (%{number})',
	'kpi_has_mapping': 'Indicateur clé de performance %{actual}',
	'kpi_has_mapping_numbered': 'Indicateur clé de performance %{actual} (%{number})',
	'kpi_no_mapping': 'Indicateur clé de performance vide',
	'kpi_no_mapping_numbered': 'Indicateur clé de performance vide (%{number})',
	'kpi_named': 'Indicateur clé de performance %{name}',
	'kpi_named_numbered': 'Indicateur clé de performance %{name} (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': 'Infographie de %{actual}',
	'infographicSummary_has_mapping_numbered': 'Infographie de %{actual} (%{number})',
	'infographicSummary_no_mapping': 'Infographie vide',
	'infographicSummary_no_mapping_numbered': 'Infographie vide (%{number})',
	'infographicSummary_named': 'Infographie %{name}',
	'infographicSummary_named_numbered': 'Infographie %{name} (%{number})',
	'noExtraText_youtube': 'Vidéo YouTube',
	'noExtraText_youtube_numbered': 'Vidéo YouTube (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': 'Vidéo YouTube %{text}',
	'one_youtube_numbered': 'Vidéo YouTube %{text} (%{number})',
	'few_youtube': 'Groupe de %{count} vidéos YouTube',
	'many_youtube': 'Groupe de %{count} vidéos YouTube',
	'noExtraText_embedMedia': 'Lien du support',
	'noExtraText_embedMedia_numbered': 'Lien du support (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': 'Lien du support %{text}',
	'one_embedMedia_numbered': 'Lien du support %{text} (%{number})',
	'few_embedMedia': 'Groupe de %{count} liens du support',
	'many_embedMedia': 'Groupe de %{count} liens du support',
	'noExtraText_media': 'Supports',
	'noExtraText_media_numbered': 'Support (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': 'Support %{text}',
	'one_media_numbered': 'Support %{text} (%{number})',
	'few_media': 'Groupe de %{count} supports',
	'many_media': 'Groupe de %{count} supports',
	'noExtraText_webpage': 'Page Web',
	'noExtraText_webpage_numbered': 'Page Web (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': 'Page Web %{text}',
	'one_webpage_numbered': 'Page Web %{text} (%{number})',
	'few_webpage': 'Groupe de %{count} pages Web',
	'many_webpage': 'Groupe de %{count} pages Web',
	'one_unknown': 'Un objet',
	'one_unknown_numbered': 'Un objet (%{number})',
	'few_unknown': 'Groupe de %{count} objets',
	'many_unknown': 'Groupe de %{count} objets',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': 'Suivant',
	'previous': 'Précédent',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': 'Le groupe de navigation en cours est %{navigation_group_name}',

	//Page Context
	'filterBlank': '(blanc)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'Impossible de charger les valeurs de filtre',
	'editTimelineHighlight': 'Editer une mise en évidence',

	'filterDockChevronLeft': 'Faire défiler les données',
	'filterDockChevronRight': 'Faire défiler les données',
	'expand': 'Développer',
	'collapse': 'Réduire',

	//Reset Dashboard
	'dashboardResetTitle': 'Réinitialiser le tableau de bord',
	'dashboardResetMessage': 'Êtes-vous sûr de vouloir réinitialiser toutes les modifications appliquées à ce tableau de bord ?',
	'dashboardResetToast': 'Votre tableau de bord a été réinitialisé.',

	//Generate PDF
	'buildingPDF': 'Génération du PDF...',
	'exportPDF': 'Exporter au format PDF',
	'pageSize': 'Taille de page',
	'orientation': 'Orientation',
	'filtersPresentPDF': 'Filtre(s) appliqué(s) à la/aux visualisation(s) sur la page précédente :',
	'errorPDF': 'Impossible de générer le PDF. Actualisez et réessayez.',
	'printPDFInfo': 'Afficher la documentation',
	'pdfWidget': 'Widget',
	'includeFilters': 'Afficher les détails du filtre',
	'portrait': 'Portrait',
	'landscape': 'Paysage',
	'letter': 'Letter (format lettre)',
	'legal': 'Legal (grand format)',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'Votre tableau de bord a été mis à niveau. Sauvegardez-le maintenant pour maintenir des performances optimales.',

	'ariaFullScreenMessage': 'Appuyez sur Echap pour quitter le mode plein écran',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': 'Graphique à paquet de bulles de hiérarchie %{categories}',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': 'Graphique à paquet de bulles de hiérarchie %{categories} (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': 'Graphique à paquet de bulles de hiérarchie vide',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': 'Graphique à paquet de bulles de hiérarchie vide (%{number})',
	'LIVE_hierarchy_packed_bubble_named': 'Graphique à paquet de bulles de hiérarchie %{name}',
	'LIVE_hierarchy_packed_bubble_named_numbered': 'Graphique à paquet de bulles de hiérarchie %{name} (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories} par %{values} - graphique marimekko',
	'LIVE_marimekko_has_mapping_numbered': '%{categories} par %{values} - graphique marimekko (%{number})',
	'LIVE_marimekko_no_mapping': 'Graphique marimekko vide',
	'LIVE_marimekko_no_mapping_numbered': 'Graphique marimekko vide (%{number})',
	'LIVE_marimekko_named': 'Graphique marimekko %{name}',
	'LIVE_marimekko_numbered': 'Graphique marimekko %{name} (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': 'Graphique en rayons de soleil %{values}',
	'LIVE_sunburst_has_mapping_numbered': 'Graphique en rayons de soleil %{values} (%{number})',
	'LIVE_sunburst_no_mapping': 'Graphique en rayons de soleil vide',
	'LIVE_sunburst_no_mapping_numbered': 'Graphique en rayons de soleil vide (%{number})',
	'LIVE_sunburst_named': 'Graphique en rayons de soleil %{name}',
	'LIVE_sunburst_named_numbered': 'Graphique en rayons de soleil %{name} (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': 'Graphique d\'analyse des pilotes %{values}',
	'LIVE_decision_analysis_has_mapping_numbered': 'Graphique d\'analyse des pilotes %{values} (%{number})',
	'LIVE_decision_analysis_no_mapping': 'Graphique d\'analyse des pilotes vides',
	'LIVE_decision_analysis_no_mapping_numbered': 'Graphique d\'analyse des pilotes vides (%{number})',
	'LIVE_decision_analysis_named': 'Graphique d\'analyse des pilotes %{name}',
	'LIVE_decision_analysis_named_numbered': 'Graphique d\'analyse des pilotes %{name} (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories} par %{columnValue} et %{lineValue} - graphique à courbes et à colonnes',
	'LIVE_line_column_opt_mapping_numbered': '%{categories} par %{columnValue} et %{lineValue} - graphique à courbes et à colonnes (%{number})',
	'LIVE_line_column_has_mapping': 'Graphique à courbes et à colonnes %{columnValue} et %{lineValue}',
	'LIVE_line_column_has_mapping_numbered': '%{categories} par %{columnValue} et %{lineValue} - graphique à courbes et à colonnes (%{number})',
	'LIVE_line_column_no_mapping': 'Graphique à courbes et à colonnes vide',
	'LIVE_line_column_no_mapping_numbered': 'Graphique à courbes et à colonnes vide (%{number})',
	'LIVE_line_column_named': 'Graphique à courbes et à colonnes %{name}',
	'LIVE_line_column_named_numbered' : 'Graphique à courbes et à colonnes %{name} (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x} par %{y} et %{size} - graphique à bulles',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x} par %{y} et %{size} - graphique à bulles (%{number})',
	'LIVE_bubble_chart_no_mapping': 'Graphique à bulles vide',
	'LIVE_bubble_chart_no_mapping_numbered': 'Graphique à bulles vide (%{number})',
	'LIVE_bubble_chart_named': 'Graphique à bulles %{name}',
	'LIVE_bubble_chart_named_numbered': 'Graphique à bulles %{name} (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': 'Graphique à puces %{actual}',
	'LIVE_bullet_has_mapping_numbered': 'Graphique à puces %{actual} (%{number})',
	'LIVE_bullet_no_mapping': 'Graphique à puces vide',
	'LIVE_bullet_no_mapping_numbered': 'Graphique à puces vide (%{number})',
	'LIVE_bullet_named': 'Graphique à puces %{name}',
	'LIVE_bullet_named_numbered': 'Graphique à puces %{name} (%{number})'
});
